import { c as _c } from "react/compiler-runtime";
import Button from '@precis-digital/kurama/Button';
import PaperclipIcon from '@precis-digital/kurama/icons/PaperclipIcon';
import { useCallback, useRef, type ReactElement } from 'react';
import { useCopilot } from 'shared/context/CopilotContext';
import { useCopilotComposerFileIntake } from 'shared/copilot/hooks/useCopilotComposerFileIntake';
import { COMPOSER_FILE_ACCEPT } from 'shared/copilot/utils/imageAttachment';
import { useTranslation } from 'shared/translations';
export const COMPOSER_FILE_INPUT_TEST_ID = 'copilot-composer-file-input';
const preventComposerActionBlur = (event: React.MouseEvent): void => {
  event.preventDefault();
};

/**
 * File attachment control for Copilot `MessageComposer` (`actions` entry).
 * Picked files go through `useCopilotComposerFileIntake`, the same path a
 * paste into the composer takes.
 */
export const CopilotComposerAttachmentAction = () => {
  const $ = _c(21);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      keyPrefix: "copilot.composer"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation("common", t0);
  const {
    isCsvUploading
  } = useCopilot();
  const {
    addFiles
  } = useCopilotComposerFileIntake();
  const fileInputRef = useRef(null);
  let t1;
  if ($[1] !== addFiles) {
    t1 = event => {
      const files = Array.from(event.target.files ?? []);
      event.target.value = "";
      addFiles(files);
    };
    $[1] = addFiles;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const handleAttachmentChange = t1;
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      display: "none"
    };
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== handleAttachmentChange) {
    t3 = <input ref={fileInputRef} type="file" accept={COMPOSER_FILE_ACCEPT} multiple={true} tabIndex={-1} aria-hidden={true} style={t2} data-testid={COMPOSER_FILE_INPUT_TEST_ID} onChange={handleAttachmentChange} />;
    $[4] = handleAttachmentChange;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <PaperclipIcon />;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = () => fileInputRef.current?.click();
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t) {
    t6 = t("attachmentTooltip");
    $[8] = t;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t6) {
    t7 = {
      kind: "singleline",
      title: t6
    };
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== t) {
    t8 = t("attachmentAria");
    $[12] = t;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== isCsvUploading || $[15] !== t7 || $[16] !== t8) {
    t9 = <Button variant="text" scheme="light" leftIcon={t4} disabled={isCsvUploading} onMouseDown={preventComposerActionBlur} onClick={t5} tooltipProps={t7} aria-label={t8} />;
    $[14] = isCsvUploading;
    $[15] = t7;
    $[16] = t8;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== t3 || $[19] !== t9) {
    t10 = <>{t3}{t9}</>;
    $[18] = t3;
    $[19] = t9;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  return t10;
};